/** The Go conflict codes a recovery action (Retry, Send now) can be refused with. Each carries an operator-specific
 *  server sentence, such as the next daily-cap slot, that the FE shows verbatim instead of a generic label. A code
 *  added on the Go side is not shown verbatim until it is added here. */
export const RECOVERY_CONFLICT_CODES = ['COOLDOWN_OVERRIDE_REQUIRED', 'NO_MAILBOX', 'DAILY_CAP_REACHED', 'MESSAGE_NOT_RECOVERABLE'] as const;
export type RecoveryConflictCode = (typeof RECOVERY_CONFLICT_CODES)[number];

export function isRecoveryConflictCode(code: unknown): code is RecoveryConflictCode {
  return typeof code === 'string' && (RECOVERY_CONFLICT_CODES as readonly string[]).includes(code);
}
